<template>
    <div>
        <div v-for="(value, key) in listObj"
            is="ShopCars"
            :shop="key"
            :cars="value">other-shop</div>
    </div>
</template>

<script>
    import showOtherShopCars from '../../../api/json/showOtherShopCars.js';
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util';

    import ShopCars from './OtherShop/ShopCars.vue';

    let locationObj = urlUtil.initByLocation();

    export default {
        data() {
            return {
                listObj: {}
            };
        },
        created() {
            showOtherShopCars(locationObj.search._object).then((data) => {
                this.listObj = data;
            });
        },
        components: {
            ShopCars
        }
    };
</script>

<style lang="less">
    
</style>



// WEBPACK FOOTER //
// OtherShop.vue?5cfb770a